// Step 19 — Evidence / provenance panel.
//
// Central promise of the intelligence workspace: for any AI-surfaced
// finding, the user must be able to see *why the AI is saying this*.
//
// Evidence is rendered from whatever the underlying row actually
// carries — Provenance objects from the intelligence layer, item IDs
// from the buyer_intel item log, contract-draft/action IDs. If a
// finding has no provenance, we say so honestly rather than invent a
// citation.

const SOURCE_LABELS = {
  workspace: "Workspace",
  owner_questionnaire: "Ägarformulär",
  risk_profile: "Riskprofil",
  valuation_engine: "Värderingsmotor",
  im_document: "IM-dokument",
  dataroom: "Dataroom",
  contracts: "Kontraktsmallar",
  contract_draft: "Kontraktsutkast",
  deal_action: "Åtgärd",
  bolagsverket: "Bolagsverket",
  annual_report: "Årsredovisning",
  user_company: "Bolagsinformation",
  buyer_intel_item: "Köpar-intelligence",
  inbound_message: "Inkommande meddelande",
  outreach_draft: "Utkast köpardialog",
};

function _sourceLabel(source) {
  if (!source) return "Okänd källa";
  const type = source.source_type;
  const base = SOURCE_LABELS[type] || type;
  const parts = [base];
  if (source.label && source.label !== base) parts.push(source.label);
  if (source.source_id) parts.push(`#${source.source_id}`);
  if (source.as_of) parts.push(`per ${source.as_of.slice(0, 10)}`);
  return parts.join(" · ");
}

export default function AIEvidencePanel({ finding }) {
  if (!finding) return null;

  const items = [];
  if (finding.source) {
    items.push({
      key: "primary",
      label: _sourceLabel(finding.source),
      hint: "Primär källa",
    });
  }
  for (const ev of finding.evidence || []) {
    if (!ev) continue;
    if (ev.provenance) {
      items.push({
        key: `p-${items.length}`,
        label: _sourceLabel(ev.provenance),
        hint: ev.label || undefined,
      });
    } else if (ev.label) {
      items.push({
        key: `l-${items.length}`,
        label: ev.label,
        hint: undefined,
      });
    }
  }

  if (items.length === 0) {
    return (
      <div className="qai-evidence-empty">
        Ingen provenienskedja finns registrerad för denna observation.
      </div>
    );
  }

  return (
    <div className="qai-evidence-panel">
      <div className="qai-evidence-title">Underlag</div>
      <ul className="qai-evidence-list">
        {items.map((it) => (
          <li key={it.key} className="qai-evidence-item">
            <span className="qai-evidence-label">{it.label}</span>
            {it.hint && <span className="qai-evidence-hint"> · {it.hint}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
